var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSleepymoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 173.726,
    height: 175.308,
    viewBox: "0 0 173.726 175.308",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(-2.297 -2.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M49.332,50.878A86.66,86.66,0,0,1,63.795,2.856a87.118,87.118,0,1,0,98.33,131.287A87.153,87.153,0,0,1,49.332,50.878Z",
    transform: "translate(0 4.247)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M55.949,45.785H35.4L55.036,9.509V6.19H15.077V19.851H33.512L13.778,56.4v3.051H55.949Z",
    transform: "translate(73.76 25.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M38.266,33.415l15.48-28.6V2.2h-31.5V12.968h14.53L21.219,41.782v2.406H54.458V33.415Z",
    transform: "translate(121.565 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepymoon);
export default __webpack_public_path__ + "static/media/sleepymoon.31791ebe3d560bbe7ef44c835e33ec3e.svg";
export { ForwardRef as ReactComponent };